import {
  PayloadAction,
  createSelector,
  createSlice,
  current,
} from "@reduxjs/toolkit";
import { GlobalState } from "../store";

const initialState = {
  isMinGameCountModalOpen: false,
  similarSeatModal: {
    isOpen: false,
    isOpened: false,
  },
  differentSeatModal: {
    isOpen: false,
    data: null,
  },
  bucketsRemainingCount: [
    {
      id: 0,
      remaining: 0,
      isComplete: false,
    },
  ],
};

export const uiHelpersState = createSlice({
  name: "uiHelpers",
  initialState,
  reducers: {
    setMinGameCountModal: (state, action: PayloadAction<boolean>) => {
      state.isMinGameCountModalOpen = action.payload;
    },
    setSimilarSeatModal: (
      state,
      action: PayloadAction<{ isOpen?: boolean; isOpened?: boolean }>
    ) => {
      const { isOpen, isOpened } = action.payload;
      const stateUpdated = { ...current(state.similarSeatModal) };
      if (isOpen !== undefined) stateUpdated.isOpen = isOpen;
      if (isOpened !== undefined) stateUpdated.isOpened = isOpened;
      state.similarSeatModal = stateUpdated;
    },
    toggleDifferentSeatModal: (
      state,
      action: PayloadAction<{ isOpen: boolean; data?: any }>
    ) => {
      state.differentSeatModal.isOpen = action.payload.isOpen;
      state.differentSeatModal.data = action?.payload?.data;
    },
    setBucketRemainingCount: (
      state,
      action: PayloadAction<
        {
          id: number;
          remaining: number;
          isComplete: boolean;
        }[]
      >
    ) => {
      state.bucketsRemainingCount = action.payload;
    },
  },
});

const selector = (state: GlobalState) => state.data.uiHelpers;
export const selectMinGameCountModal = createSelector(
  selector,
  (s) => s.isMinGameCountModalOpen
);

export const selectSimilarSeatModal = createSelector(
  selector,
  (s) => s.similarSeatModal
);

export const selectDifferentSeatModal = createSelector(
  selector,
  (s) => s.differentSeatModal
);

export const selectBucketsRemainingCount = createSelector(
  selector,
  (s) => s.bucketsRemainingCount
);
